import React from 'react';
import { UTAttachment } from '@widergy/energy-ui';
import CloudUpload from '@material-ui/icons/CloudUpload';

import styles from './styles.module.scss';

const Attachment = props => {
  const Icon = <CloudUpload className={styles.icon} />;

  return <UTAttachment icon={Icon} {...props} />;
};

export default Attachment;
